import { 
    UPDATE_BRAND_MANUFACTURE_DATA,
    SET_INITIAL_DATA,
    CONTENT_UNIT_HANDLE_CHANGE,
    RESET_CONTENT_UNIT_DATA,
    CONTENT_UNIT_RESET,
    UPDATE_FIXED_SPECS
} from '../actions/types';

export const initState = {
    brandName: '',
    manufacturer: '',
    manufactured_details: '',
    importer: '',
    importers_detail: '',
    manufacturerMand: false,
    sendDetails: [
        {
            "sid": "122",
            "productId":null,
            "name":"brand",
            "s_filter_flag":"1",
            "values":[],
            "unit":""
        },
        {
            "sid":"",
            "values":[],
            "name":"manufacturer",
            "productId":null,
            "unit":"",
            "s_filter_flag":"",
            "isCustom":0
        },
        {
            "sid":"",
            "values":[],
            "name":"manufactured_details",
            "productId":null,
            "unit":"",
            "s_filter_flag":"",
            "isCustom":0
        },
        {
            "sid":"",
            "values":[],
            "name":"importer",
            "productId":null,
            "unit":"",
            "s_filter_flag":"",
            "isCustom":0
        },
        {
            "sid":"",
            "values":[],
            "name":"importers_detail",
            "productId":null,
            "unit":"",
            "s_filter_flag":"",
            "isCustom":0
        },
    ],
    installData  : [
        {
            "name": "ins_days",
            "values": [],
            "s_nm": "Installation Days",
            "isCustom": 1,
            "s_type": ""
        },
        {
            "name": "ins_amount",
            "values": [],
            "s_nm": "Installation Amount",
            "isCustom": 1,
            "s_type": ""
        },
        {
            "name": "ins_cover",
            "s_nm": "Covered under Standard Installation",
            "values": [],
            "isCustom": 1,
            "s_type": ""
        },
        {
            "name": "ins_not_cover",
            "values": [],
            "s_nm": "Not Covered under Standard Installation",
            "isCustom": 1,
            "s_type": ""
        }
    ],
    contentWeightUnit: {
        contentPerPiece: {
            value: [],
            error: ""
        },
        unitPerPiece: {
            value: [],
            error: ""
        }
    },
    contentWeightUnitSaved: {},
    detailsSpecification: [],
    brandSpec: [],
    moq_require: 0,
    fixedSpecs: []
}

function deepCopy(json){
    return JSON.parse(JSON.stringify(json));
}

export default (state = deepCopy(initState), { type , payload }) => {
    switch(type) {
        case SET_INITIAL_DATA: 
            return deepCopy(initState)
            break;
        case CONTENT_UNIT_RESET:
            return {
                ...state,
                contentWeightUnit: deepCopy(initState.contentWeightUnit),
                contentWeightUnitSaved: state.contentWeightUnitSaved
            }
        case UPDATE_BRAND_MANUFACTURE_DATA:
            return { 
                ...state, 
                ...payload
            }
        case CONTENT_UNIT_HANDLE_CHANGE:
            const {contentWeightUnit} = payload;
            return {
                ...state,
                contentWeightUnit
            }
        case RESET_CONTENT_UNIT_DATA:
            return {
                ...state, 
                contentWeightUnit: deepCopy(initState.contentWeightUnit)
            }
        case UPDATE_FIXED_SPECS: 
            return {
                ...state,
                fixedSpecs: payload
            }
        default: {
            return state;
        }
    }
}
